import React from "react";
import { Helmet } from "react-helmet";
import { HiOutlineDocumentDownload } from "react-icons/hi";

function EOA() {
  const eoaDocuments = [
    { year: "2025-2026", title: "Extension of Approval (EOA) 2025-26", link: "/EOA/EOA Report 2025-26.PDF" },
    { year: "2024-2025", title: "Extension of Approval (EOA) 2024-25", link: "/EOA/EOA Report 2024-2025.PDF" },
    { year: "2024-2025", title: "Three Year Approval Letter 2024-2025", link: "/EOA/Three Year Approval Letter 2024-2025.PDF" },
    { year: "2023-2024", title: "Extension of Approval (EOA) 2023-24", link: "/EOA/EOA-Report-2023-24.PDF" },
    { year: "2022-2023", title: "Extension of Approval (EOA) 2022-23", link: "/EOA/EOA-Report 22-23.PDF" },
    { year: "2021-2022", title: "Extension of Approval (EOA) 2021-22", link: "/EOA/EOA Report_21-22.PDF" },
    { year: "2020-2021", title: "Extension of Approval (EOA) 2020-21", link: "/EOA/EOA_Report_2020-21.PDF" },
    { year: "2019-2020", title: "Extension of Approval (EOA) 2019-20", link: "/EOA/EOA Report 2019-20.PDF" },
    { year: "2018-2019", title: "Extension of Approval (EOA) 2018-19", link: "/EOA/EOA Report_2018-19.PDF" },
  ];

  return (
    <>
      <Helmet>
        <title>EOA Documents - VBU MCA</title>
      </Helmet>
      <div className="PageContainer">
        <div id="Heading">
          <h1>Extension of Approval (EOA)</h1>
        </div>
        <div className="EoaContainer" data-aos="fade-up">
          <p className="EoaDesc">
            The University Department of Computer Application, Vinoba Bhave University, maintains its AICTE approval annually. Below are the official Extension of Approval (EOA) documents from AICTE.
          </p>
          
          <div className="EoaGrid">
            {eoaDocuments.map((doc, index) => (
              <div key={index} className="EoaCard" data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="EoaCardIcon">
                  <HiOutlineDocumentDownload size={40} />
                </div>
                <div className="EoaCardContent">
                  <h3>{doc.year}</h3>
                  <p>{doc.title}</p>
                  <a href={doc.link} target="_blank" rel="noreferrer" className="DownloadBtn">
                    View Report
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default EOA;
